<div class="logo my-5 text-center" style="margin: auto;">
    <img src="../../../assets/WhatsApp Image 2022-08-02 at 5.41.07 AM.jpeg" alt="" routerLink="/">
    <h5 class="display-5">Contact Us</h5>
    <div style="display: flex; justify-content: center; align-items: center;">
      <img src="../../../assets/call.png" alt="" style="width: 25px; height: 25px; margin-right: 0.3rem; margin-top: -7px;">
      <h5 class="margin: 0">+9183054 55495</h5>
    </div>
  </div>
<div style="max-width: 500px; padding: 0 1rem; margin: 0 auto 5rem auto;">
    <div class="main-content">
        <div class="input-group input-group-lg mb-3">
            <input type="text" class="form-control" placeholder="Name*" [(ngModel)]="contactUs.name">
          </div>
          <div class="input-group input-group-lg mb-3">
            <input type="text" class="form-control" placeholder="Email*" [(ngModel)]="contactUs.email">
          </div>
          <div class="input-group input-group-lg mb-3">
            <input type="text" class="form-control" placeholder="Subject*" [(ngModel)]="contactUs.subject">
          </div>
          <div class="input-group input-group-lg mb-3">
            <textarea class="form-control" placeholder="Message*" [(ngModel)]="contactUs.message" rows="5"></textarea>
          </div>
          <div class="input-group input-group-lg">
            <input type="file" class="form-control" (change)="onFileSelected($event)">
          </div>
          <small>File size limit: 2Mb</small>
          <div class="alert alert-danger text-center" role="alert" *ngIf="showEmptyFieldsError == true">
            Fill all *mandatory fields!
          </div>
          <hr>
          <div style="display: flex;">
            <div style="margin-right: auto;" *ngIf="contactMessage">
                {{ contactMessage }}
              </div>
              <div style="margin-left: auto;">
                <button type="button" class="btn btn-primary" (click)="onSendContact()">Send</button>
              </div>
          </div>
    </div>
    <div class="text-center my-4">
        <small style="cursor: pointer; color: gray; text-decoration: underline;" routerLink="/">Go To Homepage</small>
    </div>
</div>